import { get } from "lodash-es";
import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import type { Operator } from "../models/Operator";

type GetOperatorsParams = {
	operatorId?: number | null;
	includeDisabled?: boolean;
};

interface OperatorAssetAssignment {
	AssetId: number;
	AssetName: string;
}

interface UpsertOperatorPayload extends Operator {
	AssetIds: number[];
}

export const getOperators = async (
	{ operatorId = null, includeDisabled = true }: GetOperatorsParams,
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "OperatorId", value: operatorId },
		{ name: "IncludeDisabled", value: includeDisabled },
	];

	const resp = await apiService.callV2(
		"[MES].[GetOperators]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Operator[];
	}

	throw new Error(resp.message || "Error fetching operators");
};

export const upsertOperator = async (operator: UpsertOperatorPayload) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "OperatorId", value: operator.OperatorId },
		{ name: "OperatorName", value: operator.OperatorName.trim() },
		{ name: "Enabled", value: operator.Enabled },
		{ name: "AssetIdsCSV", value: operator.AssetIds.join(",") },
	];

	const resp = await apiService.callV2("[MES].[UpsertOperator]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number | null;
	}

	throw new Error(resp.message || "Error saving operator");
};
export const getOperatorAssets = async (
	operatorId: number,
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OperatorId", value: operatorId }];

	const resp = await apiService.callV2(
		"[MES].[GetOperatorAssets]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as OperatorAssetAssignment[];
	}

	throw new Error(resp.message || "Error fetching operator assets");
};

export const deleteOperator = async (operatorId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OperatorId", value: operatorId }];

	const resp = await apiService.callV2("[MES].[DeleteOperator]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting operator");
	}
};
